// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"GameInfos_wrapper_1D5GB","icon":"GameInfos_icon_1IJ62","infos":"GameInfos_infos_26ipY","name":"GameInfos_name_aJHSA","date":"GameInfos_date_1N4Gl"};